import { useStore } from 'zustand'
import { createStore } from 'zustand/vanilla'

interface AuthTokenState {
  token: string | null
  setToken: (token: string | null) => void
}

const STORAGE_KEY = 'admin-token'

// Статический ADMIN_TOKEN живёт в sessionStorage вкладки: переживает refresh,
// умирает с закрытием вкладки. localStorage (долгий персист на диске) запрещён —
// rule env-local.
export const authTokenStore = createStore<AuthTokenState>()((set) => ({
  token: sessionStorage.getItem(STORAGE_KEY),
  setToken: (token) => {
    if (token === null) sessionStorage.removeItem(STORAGE_KEY)
    else sessionStorage.setItem(STORAGE_KEY, token)
    set({ token })
  },
}))

export function useAuthToken(): string | null {
  return useStore(authTokenStore, (s) => s.token)
}
